import { SectionHeading, UserGeneratedHtml } from '@atlassian/mpac-ui';
import React from 'react';
import { TEST_ID } from '../../../../../constants';
import { Section } from '../../../../Section';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MoreDetails = _ref => {
  let {
    showHeading,
    moreDetails
  } = _ref;
  return /*#__PURE__*/_jsxs(Section, {
    children: [showHeading && /*#__PURE__*/_jsx(SectionHeading, {
      children: "More details"
    }), /*#__PURE__*/_jsx(UserGeneratedHtml, {
      dangerousHtml: moreDetails,
      "data-testid": TEST_ID.OVERVIEW_TAB_MORE_DETAILS_CONTENT
    })]
  });
};
MoreDetails.defaultProps = {
  showHeading: true
};
export default MoreDetails;